<script setup lang="ts">
const mission = {
  icon: 'bx-target-lock',
  iconBg: '#F9D4D0',
  iconColor: '#F27063',
  title: 'Onze Missie',
  description: 'Bij ’t SpeelFabrik organiseren we activiteiten die uitnodigen tot fantasie, creativiteit en vriendschap, steeds met respect voor elk kind als uniek individu. Ben je een dromer, bouwer of een spring-in-t-veld? Dan kan je bij ons je eigen talent ontdekken en tonen tijdens onze speelse activiteiten. We creëren een warme, veilige en speelse omgeving waar kinderen zorgeloos kunnen ontdekken, leren en groeien. ',
}

const vision = {
  icon: 'bx-glasses',
  iconBg: '#D9E8F3',
  iconColor: '#8FB5D9',
  title: 'Onze Visie',
  description: 'We streven ernaar om onze activiteiten te blijven vernieuwen. We laten ons inspireren door de kinderen zelf en bouwen zo stap voor stap aan een warme, betrouwbare omgeving waar plezier de drijvende kracht is van onze VZW! In de toekomst willen we graag onze activiteiten uitbreiden, steeds met aandacht voor veiligheid, inclusie en duurzaam materiaalgebruik.',
}
</script>

<template>
  <div
    id="mission-vision"
    class="values-section"
  >
    <VContainer>
      <div class="section-header">
        <div class="section-badge">
          <VIcon icon="bx-show" />
          <span>Onze Kijk</span>
        </div>
        <h2 class="section-title">
          Bouwen, Spelen, Groeien!
        </h2>
      </div>

      <VRow
        align="center"
        class="values-row"
      >
        <!-- Left Column: Mission -->
        <VCol
          cols="12"
          md="5"
          class="values-col-left"
        >
          <div class="value-card large">
            <div
              class="value-icon-wrapper"
              :style="{ background: mission.iconBg }"
            >
              <VIcon
                :icon="mission.icon"
                size="48"
                :style="{ color: mission.iconColor }"
              />
            </div>
            <div class="value-content">
              <h3 class="value-title">
                {{ mission.title }}
              </h3>
              <p class="value-description">
                {{ mission.description }}
              </p>
            </div>
          </div>
        </VCol>

        <!-- Center: Image -->
        <VCol
          cols="12"
          md="2"
          class="image-col-center"
        >
          <div class="center-icon">
            <VIcon
              icon="bx-heart"
              size="80"
            />
          </div>
        </VCol>

        <!-- Right Column: Vision -->
        <VCol
          cols="12"
          md="5"
          class="values-col-right"
        >
          <div class="value-card large">
            <div
              class="value-icon-wrapper"
              :style="{ background: vision.iconBg }"
            >
              <VIcon
                :icon="vision.icon"
                size="48"
                :style="{ color: vision.iconColor }"
              />
            </div>
            <div class="value-content">
              <h3 class="value-title">
                {{ vision.title }}
              </h3>
              <p class="value-description">
                {{ vision.description }}
              </p>
            </div>
          </div>
        </VCol>
      </VRow>
    </VContainer>

    <!-- Decorative wave bottom -->
    <div class="wave-bottom">
      <svg
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,40 C300,100 500,0 800,40 L1200,60 L1200,120 L0,120 Z"
          fill="#8FB5D9"
          opacity="0.3"
        />
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.values-section {
  position: relative;
  overflow: hidden;
  background: rgb(var(--v-theme-surface));
  padding-block: 5rem;
}

.section-header {
  margin-block-end: 4rem;
  text-align: center;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  background: rgba(242, 112, 99, 10%);
  color: #f27063;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  gap: 0.5rem;
  letter-spacing: 0.5px;
  margin-block-end: 1.5rem;
  padding-block: 0.5rem;
  padding-inline: 1.5rem;
  text-transform: uppercase;

  .v-icon {
    color: currentcolor;
  }
}

.section-title {
  margin: 0;
  color: rgb(var(--v-theme-on-surface));
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  line-height: 1.2;
  margin-block-end: 1rem;
}

.values-row {
  align-items: stretch;
}

.values-col-left,
.values-col-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2.5rem;
}

.value-card {
  display: flex;
  gap: 1.5rem;
}

.value-icon-wrapper {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  block-size: 70px;
  inline-size: 70px;
}

.value-content {
  flex: 1;
}

.value-title {
  color: #2c3e50;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.3;
  margin-block-end: 0.75rem;
}

.value-description {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
}

.image-col-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.graduate-wrapper {
  position: relative;
  inline-size: 100%;
  max-inline-size: 400px;
}

.yellow-blob {
  position: absolute;
  z-index: 1;
  border-radius: 50% 50% 40% 60% / 60% 40% 60% 40%;
  animation: blob-float 6s ease-in-out infinite;
  background: #d89441;
  block-size: 90%;
  inline-size: 90%;
  inset-block-start: 5%;
  inset-inline-start: 5%;
}

.graduate-image {
  position: relative;
  z-index: 2;
  border-radius: 50%;
  block-size: auto;
  inline-size: 100%;
  object-fit: cover;
}

.graduation-cap {
  position: absolute;
  z-index: 3;
  animation: cap-tilt 3s ease-in-out infinite;
  font-size: 4rem;
  inset-block-start: -30px;
  inset-inline-start: 50%;
  transform: translateX(-50%) rotate(-15deg);
}

.wave-bottom {
  position: absolute;
  z-index: 1;
  inline-size: 100%;
  inset-block-end: 0;
  inset-inline-start: 0;
}

@keyframes blob-float {
  0%,
  100% {
    border-radius: 50% 50% 40% 60% / 60% 40% 60% 40%;
    transform: rotate(0deg);
  }

  50% {
    border-radius: 40% 60% 50% 50% / 50% 60% 40% 60%;
    transform: rotate(5deg);
  }
}

@keyframes cap-tilt {
  0%,
  100% {
    transform: translateX(-50%) rotate(-15deg);
  }

  50% {
    transform: translateX(-50%) rotate(-10deg);
  }
}

@media (max-width: 960px) {
  .values-row {
    gap: 3rem;
  }

  .values-col-left,
  .values-col-right {
    gap: 2rem;
  }

  .image-col-center {
    order: -1;
    margin-block-end: 2rem;
  }

  .graduate-wrapper {
    max-inline-size: 300px;
  }
}

@media (max-width: 600px) {
  .values-section {
    padding-block: 4rem 6rem;
  }

  .value-card {
    flex-direction: column;
    gap: 1rem;
  }

  .value-icon-wrapper {
    block-size: 60px;
    inline-size: 60px;
  }

  .graduation-cap {
    font-size: 3rem;
    inset-block-start: -20px;
  }
}

// Old unused styles below - to be cleaned up
.characters-section {
  position: relative;
  overflow: hidden;
  background: rgb(var(--v-theme-surface));
  padding-block: 5rem;
}

.characters-header {
  margin-block-end: 4rem;
  text-align: center;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  border: 3px solid #e87b35;
  border-radius: 50px;
  background: rgba(255, 255, 255, 90%);
  gap: 0.5rem;
  margin-block-end: 1.5rem;
  padding-block: 0.75rem;
  padding-inline: 2rem;
}

.badge-emoji {
  animation: bounce 2s ease-in-out infinite;
  font-size: 1.5rem;
}

.badge-text {
  color: #e87b35;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
}

.characters-title {
  color: #fff;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-block-end: 1rem;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 20%);
}

.characters-subtitle {
  color: #fff;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 400;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 10%);
}

.characters-grid {
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  margin-block-end: 4rem;
  margin-inline: auto;
  max-inline-size: 1400px;
}

.card-inner {
  position: relative;
  z-index: 2;
  overflow: hidden;
  border-radius: 32px;
  padding-block: 3rem;
  padding-inline: 2rem;
  text-align: center;
  transition: all 0.3s ease;
}

.character-emoji-wrapper {
  position: relative;
  block-size: 120px;
  inline-size: 120px;
  margin-block-end: 1.5rem;
  margin-inline: auto;
}

.emoji-circle {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid rgba(255, 255, 255, 50%);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 30%);
  block-size: 120px;
  inline-size: 120px;
}

.character-emoji {
  animation: emoji-float 3s ease-in-out infinite;
  font-size: 4rem;
}

.emoji-glow {
  position: absolute;
  border-radius: 50%;
  animation: glow-pulse 2s ease-in-out infinite;
  background: rgba(255, 255, 255, 35%);
  inset: -10px;
}

.character-name {
  color: #fff;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 2rem;
  font-weight: 700;
  margin-block-end: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 20%);
}

.character-badge {
  display: inline-block;
  border-radius: 50px;
  background: rgba(255, 255, 255, 90%);
  color: #333;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-block-end: 1.5rem;
  padding-block: 0.5rem;
  padding-inline: 1.5rem;
  text-transform: uppercase;
}

.character-description {
  color: #fff;
  font-size: 1.1rem;
  line-height: 1.7;
  margin-block-end: 1.5rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 10%);
}

.fun-fact {
  display: inline-flex;
  align-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 20%);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  gap: 0.5rem;
  padding-block: 0.75rem;
  padding-inline: 1.25rem;
}

.floating-shapes {
  position: absolute;
  overflow: hidden;
  inset: 0;
  pointer-events: none;
}

.float-shape {
  position: absolute;
  animation: float 4s ease-in-out infinite;
  animation-play-state: paused;
  color: rgba(255, 255, 255, 30%);
  font-size: 1.5rem;

  &.shape-1 {
    inset-block-start: 20%;
    inset-inline-start: 10%;
  }

  &.shape-2 {
    animation-delay: 1s;
    inset-block-start: 70%;
    inset-inline-end: 15%;
  }

  &.shape-3 {
    animation-delay: 2s;
    inset-block-start: 40%;
    inset-inline-end: 10%;
  }

  &.shape-4 {
    animation-delay: 1.5s;
    inset-block-start: 60%;
    inset-inline-start: 15%;
  }
}

.card-shadow {
  position: absolute;
  z-index: 1;
  border-radius: 32px;
  filter: blur(20px);
  inset: 20px;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.character-card {
  position: relative;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-12px);

    .card-inner {
      transform: translateY(-8px);
    }

    .card-shadow {
      transform: translateY(8px) scale(1.05);
    }

    .float-shape {
      animation-play-state: running;
    }
  }
}

.characters-cta {
  position: relative;
  text-align: center;
}

.cta-text {
  position: relative;
  z-index: 2;
}

.cta-icon {
  transition: all 0.4s ease;
}

.button-shine {
  position: absolute;
  background: rgba(255, 255, 255, 25%);
  block-size: 100%;
  inline-size: 50%;
  inset-block-start: 0;
  inset-inline-start: -100%;
  transition: inset-inline-start 0.6s ease;
}

.cta-button {
  position: relative;
  overflow: hidden;
  border-radius: 60px;
  background: #e87b35;
  box-shadow: 0 12px 40px rgba(232, 123, 53, 40%);
  color: #fff;
  font-family: "Peachy Kee JF", "Public Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  padding-block: 1.5rem;
  padding-inline: 4rem;
  text-transform: none;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 16px 48px rgba(232, 123, 53, 50%);
    transform: translateY(-4px) scale(1.05);

    .cta-icon {
      transform: translateX(8px) rotate(360deg);
    }

    .button-shine {
      inset-inline-start: 100%;
    }
  }
}

.confetti-container {
  position: absolute;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 50%;
  pointer-events: none;
  transform: translateX(-50%);
}

.confetti-piece {
  position: absolute;
  animation: confetti-fall 1s ease-out forwards;
  block-size: 10px;
  inline-size: 10px;
  inset-block-start: 0;
}

.bg-decorations {
  position: absolute;
  overflow: hidden;
  inset: 0;
  pointer-events: none;
}

.decoration {
  position: absolute;
  animation: decoration-float 8s ease-in-out infinite;
  color: rgba(255, 255, 255, 30%);
  font-size: 3rem;

  &.decoration-1 {
    inset-block-start: 10%;
    inset-inline-start: 5%;
  }

  &.decoration-2 {
    animation-delay: 1s;
    inset-block-start: 20%;
    inset-inline-end: 10%;
  }

  &.decoration-3 {
    animation-delay: 2s;
    inset-block-start: 60%;
    inset-inline-start: 8%;
  }

  &.decoration-4 {
    animation-delay: 3s;
    inset-block-start: 70%;
    inset-inline-end: 15%;
  }

  &.decoration-5 {
    animation-delay: 1.5s;
    inset-block-start: 85%;
    inset-inline-start: 50%;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

@keyframes emoji-float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-10px) rotate(5deg);
  }
}

@keyframes glow-pulse {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }

  50% {
    opacity: 0.6;
    transform: scale(1.2);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

@keyframes confetti-fall {
  0% {
    opacity: 1;
    transform: translateY(0) rotate(0deg);
  }

  100% {
    opacity: 0;
    transform: translateY(400px) rotate(720deg);
  }
}

@keyframes decoration-float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-30px) rotate(180deg);
  }
}

.confetti-enter-active,
.confetti-leave-active {
  transition: opacity 0.3s ease;
}

.confetti-enter-from,
.confetti-leave-to {
  opacity: 0;
}

@media (max-width: 960px) {
  .characters-title {
    font-size: 2.5rem;
  }

  .characters-subtitle {
    font-size: 1.25rem;
  }

  .characters-grid {
    gap: 2rem;
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .characters-section {
    padding-block: 3rem;
  }

  .characters-title {
    font-size: 2rem;
  }

  .characters-subtitle {
    font-size: 1.1rem;
  }

  .character-name {
    font-size: 1.75rem;
  }

  .cta-button {
    font-size: 1.25rem;
    padding-block: 1.25rem;
    padding-inline: 3rem;
  }
}
</style>
